import $ from "cash-dom"
globalThis.$ = $
globalThis.aipDisplayTag
globalThis.aiptag
globalThis.adplayer